<template>
  <div class="overflw">
    <!-- 顶部 -->
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no"
    />
    <header>
      <div class="header-content">
        <div class="header-content-box">
          <div class="header-content-box-bg">
            <img src="/static/home/top-bg.png" alt="" />
            <!-- <img src="/static/home/top-person.png" alt="" /> -->
          </div>
          <div class="not-message">
            <!-- class="link-style" -->
            <van-notice-bar
              scrollable
              background="transparent"
              color="#0F0F0F"
              :text="noticebartext"
            />
          </div>
          <div class="header-content-logo-and-search">
            <img src="/static/home/logo.png" alt="" />
            <img @click="searchChange" src="/static/home/search.png" alt="" />
          </div>
        </div>
      </div>
    </header>
    <!-- 分类 -->
    <main>
      <div class="classfiy">
        <div class="classfiy-content">
          <div
            class="classfiy-list"
            @click="navigationMoreChange(s, k)"
            v-for="(s, k) in classfiyData"
            :key="k"
          >
            <img :src="s.image" alt="" />
            <span>{{ s.text }}</span>
          </div>
        </div>
      </div>
    </main>

    <!-- 平台策划活动 -->
    <main>
      <div class="plan">
        <div class="plan-content">
          <div class="plan-one-image" @click="openStartChange">
            <img src="/static/home/plan.png" alt="" />
            <img src="/static/home/start.png" alt="" />
          </div>
        </div>
      </div>
    </main>
    <!-- 绘本视频列表 -->
    <main>
      <div class="video-content">
        <div class="video-content-box">
          <img src="/static/home/video.png" alt="" />
        </div>
        <div class="video-play-list">
          <div class="video-play-list-content">
            <div
              class="video-play"
              @click="openInfoChange(s, 0)"
              v-for="(s, k) in getRecommendDataVideo"
              :key="k"
            >
              <div class="video-play-img">
                <img :src="imageurl + s?.imgUrl" alt="" />
                <img src="/static/home/play.png" alt="" />
              </div>
              <div class="video-text">
                <span>{{ s?.resName }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <!-- 历史美文列表 -->
    <main>
      <div class="article">
        <div class="article-content">
          <div class="article-content-box">
            <img src="/static/home/article.png" alt="" />
            <div class="article-right" @click="ChangeABatch">
              <span>换一批</span>
              <img src="/static/home/batch.png" alt="" />
            </div>
          </div>

          <div class="article-list">
            <div class="article-list-content">
              <div
                class="article-list-each"
                @click="openUrl(s)"
                v-for="(s, k) in getRecommendData"
                :key="k"
              >
                <div class="article-left-image">
                  <img :src="newImageUrl + s?.imgUrl" alt="" />
                </div>
                <div class="article-right-text">
                  <span>{{ s.title }}</span>
                  <span>{{ s?.subhead }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <!-- 历史人物列表 -->
    <main>
      <div class="character">
        <div class="character-content">
          <div class="character-content-box">
            <img src="/static/home/character-title.png" alt="" />
            <div
              class="character-more"
              @click="specialChange('260125268738580480', 7)"
            >
              <span>更多</span>
              <img src="/static/home/arrow.png" alt="" />
            </div>
          </div>
          <div class="character-list">
            <div class="character-list-content">
              <div
                class="character-list-each"
                @click="openInfoChange(s, 1)"
                v-for="(s, k) in historyPerson"
                :key="k"
              >
                <img :src="imageurl + s?.imgUrl" alt="" />
                <span>{{ s.title }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <!-- 红色专栏列表 -->
    <main>
      <div class="special">
        <div class="special-content">
          <div class="special-content-box">
            <img src="/static/home/red.png" alt="" />
            <div
              class="special-more"
              @click="specialChange('260125264988872704', 5)"
            >
              <span>更多</span>
              <img src="/static/home/arrow.png" alt="" />
            </div>
          </div>
          <div class="special-swiper">
            <div class="special-swiper-content">
              <div class="special-swiper-list">
                <div
                  class="swiper-list"
                  @click="openInfoChange(s, 2)"
                  v-for="(s, k) in specialPerson"
                  :key="k"
                >
                  <img :src="imageurl + s.imgUrl" alt="" />
                  <img src="/static/video/video.png" alt="" />
                  <!-- <video
                  src="https://lf3-static.bytednsdoc.com/obj/eden-cn/0eh7lpquhpanuhf/20240730-162950.mp4"
                  loop
                ></video> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <!-- 绘说天下列表 -->
    <!-- 绘说天下列表 -->
    <main>
      <div class="world">
        <div class="world-content">
          <div class="world-content-box">
            <img src="/static/home/world.png" alt="" />
            <div class="world-more" @click="moreViode">
              <span>更多</span>
              <img src="/static/home/arrow.png" alt="" />
            </div>
          </div>
          <div class="world-list">
            <div class="world-list-content">
              <div
                class="world-list-each"
                @click="moreChange(s)"
                v-for="(s, k) in PaintingTheWorld"
                :key="k"
              >
                <img :src="imageurl + s?.imgUrl" alt="" />
                <img src="/static/video/video.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>

    <!-- 底部导航 -->
    <footer>
      <bottomHeader :currentIndex="0" />
    </footer>
  </div>
</template>

<script>
import { generalPOST, imageurl, newImageUrl } from "@/requset/requset";
import bottomHeader from "@/components/bottomHeader.vue";
import { addAccessStatistics } from "@/api/statistics";
export default {
  components: {
    bottomHeader,
  },
  data() {
    return {
      imageurl,
      newImageUrl,
      noticebartext: "",
      classfiyData: [],
      historyPerson: [],
      specialPerson: [],
      getRecommendDataVideo: null,
      getRecommendData: null,
      PaintingTheWorld: [],
      functionIds: null,
      functions: null,
      towfunctions: null,
    };
  },
  methods: {
    async addAccessStatistics() {
      await addAccessStatistics({ terminal: 1, content: "首页" });
    },
    searchChange() {
      this.$router.push({ name: "onsearch" });
    },
    openStartChange() {
      this.$router.push({ name: "plan" });
    },
    navigationMoreChange(s, k) {
      this.$router.push(`search?id=${s?.id}&currentIndex=${k}`);
    },
    moreViode() {
      this.$router.push("video");
    },
    recommendData() {
      generalPOST("recommend/getRecommend", "").then(async (res) => {
        if (res) {
          this.getRecommendDataVideo = res.data?.resourcesList?.records;
        }
      });
    },
    moreChange(s) {
      this.$router.push(
        `videoInfo?id=${s?.id}&title=绘说天下&functionId=697867056141574144`
      );
    },
    ChinaOrTheWorld() {
      generalPOST(
        `resList/getResList?functionId=697867056141574144&pageNo=1&pageSize=10`,
        ""
      ).then(async (res) => {
        if (res) {
          this.PaintingTheWorld = res.data?.records?.splice(0, 2);
        }
      });
    },
    ChangeABatch() {
      generalPOST(`homepage/getRandomArticle`, ``).then(async (res) => {
        if (res) {
          this.getRecommendData = res?.data;
        }
      });
    },
    openUrl(s) {
      window.location.href = s?.url;
    },
    openInfoChange(s, index) {
      this.classfiyData.map((items) => {
        if (items.text == "一带一路") {
          this.functionIds = items?.id;
        } else if (items.text == "历史人物") {
          this.functions = items?.id;
        } else if (items.text == "革命英雄") {
          this.towfunctions = items?.id;
        }
      });
      this.$router.push(
        `videoInfo?id=${
          s?.resId ? s?.resId : s?.contentId ? s?.contentId : s?.parentId
        }&title=${
          index == 0 ? "一带一路" : index == 1 ? "历史人物" : "革命英雄"
        }&functionId=${
          index == 0
            ? 0
            : index == 1
            ? this.functions
            : this.towfunctions == undefined
            ? ""
            : this.towfunctions
        }`
      );
    },
    specialChange(s, k) {
      this.$router.push(`search?id=${s}&currentIndex=${k}`);
    },
    getLoginChange() {
      const tokenAuth = window.location.href;
      if (tokenAuth) {
        const towtokenAuth = tokenAuth.split("?tokenAuth=")[1]
          ? tokenAuth.split("?tokenAuth=")[1]
          : window.localStorage.getItem("tokenAuth")
          ? window.localStorage.getItem("tokenAuth")
          : tokenAuth.split("?tokenAuth=")[1];
        if (towtokenAuth) {
          window.localStorage.setItem("tokenAuth", towtokenAuth);

          // 清除URL中的token参数
          if (window.history.replaceState) {
            const cleanURL = window.location.origin + window.location.pathname;
            window.history.replaceState(null, null, cleanURL);
          }

          generalPOST(
            `cusLogin/urlTokenLogin?tokenAuth=${towtokenAuth}`,
            ""
          ).then(async (res) => {
            if (res) {
              if (!res.data?.customerId || !res.data?.customer) {
                this.$router.push({ name: "noqx" });
              } else {
                window.localStorage.setItem("names", res.data?.customer);
                window.localStorage.setItem("token", res.data?.customerId);

                // 绘说天下
                this.ChinaOrTheWorld();
                // 换一批
                this.ChangeABatch();
                // 热门列表
                this.recommendData();
                this.noticebartext =
                  `欢迎来到` + " " + window.localStorage.getItem("names");
                // 获取顶部分类接口
                generalPOST("homepage/getClassify", {}).then(async (res) => {
                  if (res.data) {
                    res.data?.functions.map((items) => {
                      this.classfiyData.push({
                        image: imageurl + items.url,
                        text: items.title,
                        ...items,
                      });
                    });
                    // 判断当cusMod列表有数据的情况下取第一个子级
                    if (res.data?.cusMod.length > 0) {
                      this.historyPerson = res.data?.cusMod[0].children;
                      this.specialPerson = res.data?.cusMod[1].children;
                    }
                  }
                });
              }
            }
          });
        } else {
          this.$router.push({ name: "noqx" });
        }
      }
    },
  },
  mounted() {
    this.getLoginChange();
    window.removeEventListener("scroll", () => {});
    this.addAccessStatistics();
  },
};
</script>
<style lang="scss" scoped>
.link-style {
  padding-left: 22%;
}
.header-content {
  .header-content-box {
    .header-content-box-bg {
      img {
        height: 8.125rem;
        width: 100%;
        position: absolute;
        top: 0;
        z-index: -1;
        //   &:nth-last-child(1) {
        //    width: calc(58px / 1.5);
        //    height: calc(86px / 1.5);
        //    top: 4.375rem;
        //   left: 2.275rem;
        //    z-index: 2;
        // }
      }
    }
    .header-content-logo-and-search {
      padding-top: 1.75rem;
      padding-left: 0.8125rem;
      padding-right: 0.9375rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      img {
        width: 1.125rem;
        height: 1.125rem;
        &:nth-child(1) {
          width: 6.4375rem;
          height: 2.5rem;
        }
      }
    }
  }
}

//classfiy
.classfiy {
  margin-top: 7rem;

  .classfiy-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    background: rgba(255, 253, 236);
    margin-top: -0.9375rem;
    position: relative;
    .classfiy-list {
      width: calc(100% / 4);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;
      height: 5.5rem;
      img {
        height: 3.875rem;
        margin-bottom: 0.625rem;
      }
      span {
        font-family: PingFang SC;
        font-weight: 500;
        font-size: 0.875rem;
        color: #0f0f0f;
      }
      &:nth-child(1) {
        margin-bottom: 1.25rem;
        img {
          width: 3.875rem;
          height: 3.875rem;
        }
      }
      &:nth-child(2) {
        margin-bottom: 1.25rem;
        img {
          width: 3.4375rem;
          height: 3.5938rem;
        }
      }
      &:nth-child(3) {
        margin-bottom: 1.25rem;
        img {
          width: 4.6875rem;
          height: 3.5938rem;
        }
      }
      &:nth-child(4) {
        margin-bottom: 1.25rem;
        img {
          width: 4.8125rem;
          height: 3.875rem;
        }
      }
      &:nth-child(5) {
        img {
          width: 2.9063rem;
          height: 3.2813rem;
        }
      }
      &:nth-child(6) {
        img {
          width: 2.0625rem;
          height: 3.8125rem;
        }
      }
      &:nth-child(7) {
        img {
          width: 5.25rem;
          height: 2.375rem;
        }
        span {
          margin-top: 0.625rem;
        }
      }
      &:nth-child(8) {
        img {
          width: 2.0938rem;
          height: 3.5313rem;
        }
      }
    }
  }
}

//plan
.plan {
  margin-top: 1.875rem;
  .plan-content {
    .plan-one-image {
      position: relative;
      display: flex;
      img {
        width: 100%;
        height: 7rem;
        background-size: cover;
        &:nth-child(1) {
          //
          margin-left: 0.45rem;
        }
        &:nth-child(2) {
          width: 6rem;
          height: 2rem;
          position: absolute;
          bottom: 2rem;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
  }
}

// video
.video-content {
  margin-left: 0.9375rem;
  .video-content-box {
    img {
      height: 2.25rem;
      width: 4.6875rem;
      object-fit: cover;
    }
  }
  .video-play-list {
    margin-top: 0.625rem;
    .video-play-list-content {
      display: flex;
      align-items: center;
      white-space: nowrap;
      overflow-x: scroll;
      .video-play {
        margin-right: 0.625rem;
        .video-play-img {
          width: 5.3125rem;
          height: 5.3125rem;
          position: relative;
          overflow: hidden;
          border-radius: 12px;
          &::after {
            width: 100%;
            height: 100%;
            content: "";
            position: absolute;
            background: linear-gradient(
              rgba(29, 20, 0, 0) 0%,
              rgba(29, 20, 0, 0.4) 100%
            );
            left: 0;
            top: 0;
          }
          img {
            object-fit: cover;
            width: 100%;
            height: 100%;
            &:nth-last-child(1) {
              width: 1.25rem;
              height: 1.25rem;
              position: absolute;
              right: 0.25rem;
              bottom: 0.25rem;
              z-index: 1;
            }
          }
        }
        .video-text {
          margin-top: 0.375rem;
          span {
            font-family: PingFang SC;
            font-weight: 500;
            font-size: 0.875rem;
            color: #0f0f0f;
            display: block;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 100px;
          }
        }
      }
    }
  }
}

.article {
  margin: 0 0.9375rem;
  margin-top: 1.25rem;
  .article-content {
    .article-content-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      > img {
        height: 2.0938rem;
        width: 4.7813rem;
      }
      .article-right {
        display: flex;
        align-items: center;
        span {
          font-family: PingFang SC;
          font-weight: 500;
          font-size: 0.625rem;
          color: #1b0d00;
        }
        img {
          width: 0.9375rem;
          height: 0.75rem;
          margin-left: 0.2813rem;
        }
      }
    }

    .article-list {
      margin-top: 1.25rem;
      .article-list-content {
        .article-list-each {
          display: flex;
          align-items: center;
          margin-bottom: 0.625rem;
          &:nth-last-child(1) {
            margin-bottom: 0;
          }
          .article-left-image {
            img {
              width: 4.0625rem;
              height: 4.0625rem;
              border-radius: 0.5rem;
              object-fit: cover;
            }
          }
          .article-right-text {
            margin-left: 0.625rem;
            display: flex;
            flex-direction: column;
            justify-content: center;
            span {
              font-family: PingFang SC;
              font-weight: 500;
              font-size: 0.875rem;
              color: #0f0f0f;
              &:nth-last-child(1) {
                font-size: 0.75rem;
                color: #d1c4a6;
                margin-top: 0.3125rem;
              }
            }
          }
        }
      }
    }
  }
}

.character {
  margin: 0 0.9375rem;
  margin-top: 1.25rem;
  .character-content {
    .character-content-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      > img {
        height: 2.375rem;
        width: 4.8125rem;
      }
      .character-more {
        display: flex;
        align-items: center;
        span {
          font-family: PingFang SC;
          font-weight: 500;
          font-size: 0.625rem;
          color: #1b0d00;
        }
        img {
          width: 0.375rem;
          height: 0.75rem;
          margin-left: 0.3125rem;
        }
      }
    }
    .character-list {
      margin-top: 1.25rem;
      .character-list-content {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        .character-list-each {
          margin-bottom: 0.9375rem;
          display: flex;
          align-items: center;
          flex-direction: column;
          width: calc(100% / 4);

          img {
            object-fit: cover;
            width: 4.375rem;
            height: 4.375rem;
            border-radius: 625rem;
          }
          span {
            margin-top: 0.625rem;
            font-family: PingFang SC;
            font-weight: 500;
            font-size: 0.875rem;
            color: #0f0f0f;
          }
        }
      }
    }
  }
}

.special {
  margin-top: 0.7813rem;
  .special-content {
    .special-content-box {
      margin: 0 0.9375rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      > img {
        height: 2.9375rem;
        width: 4.875rem;
      }
      .special-more {
        display: flex;
        align-items: center;
        span {
          font-family: PingFang SC;
          font-weight: 500;
          font-size: 0.625rem;
          color: #1b0d00;
        }
        img {
          width: 0.375rem;
          height: 0.75rem;
          margin-left: 0.3125rem;
        }
      }
    }
    .special-swiper {
      // padding-bottom: 1.25rem;
      padding-top: 1.25rem;
      .special-swiper-content {
        // width: 100vw;
        // display: flex;
        width: 100%; /* 确保宽度为100% */
        display: -ms-flexbox; /* IE11 */
        display: flex;
        .special-swiper-list {
          // display: flex;
          // // align-items: center;
          // white-space: nowrap;
          // overflow-x: scroll;
          display: -ms-flexbox; /* IE11 */
          display: flex;
          -ms-flex-wrap: nowrap; /* IE11 */
          flex-wrap: nowrap;
          white-space: nowrap;
          overflow-x: auto; /* 确保滚动条可见 */
          -ms-overflow-style: -ms-autohiding-scrollbar; /* 隐藏IE滚动条 */
          .swiper-list {
            // width: 100%;
            // height: 100%;
            // position: relative;
            // display: flex;
            // height: 10rem;
            // padding: 0 0.9375rem;
            -ms-flex: 0 0 auto; /* IE11 */
            flex: 0 0 auto;
            width: auto; /* 确保宽度自动调整 */
            height: 10rem;
            padding: 0 0.9375rem;
            position: relative;
            box-sizing: border-box; /* 确保盒模型包含内边距 */
            img {
              // width: 18.375rem;
              // object-fit: cover;
              height: 95%;
              &:nth-last-child(1) {
                // position: absolute;
                // width: 2rem;
                // height: 2rem;
                // left: 50%;
                // top: 40%;
                // transform: translateX(-50%);
                // margin: 0 !important;
                // padding: 0 !important;
                position: absolute;
                width: 2rem;
                height: 2rem;
                left: 50%;
                top: 40%;
                transform: translateX(-50%);
                margin: 0 !important;
                padding: 0 !important;
              }
              &:nth-child(1) {
                border-radius: 0.5rem;
              }
            }
          }
        }
      }
    }
  }
}

::-webkit-scrollbar {
  display: none;
}

.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  height: 12.5rem;
  // width: 80% !important;
  text-align: center;
  // margin: 0 1.25rem;
}

// world
.world {
  margin: 0 0.9375rem;
  margin-top: 1.25rem;
  padding-bottom: 6rem;
  .world-content {
    .world-content-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      > img {
        height: 2.25rem;
        width: 4.8438rem;
        object-fit: cover;
      }
      .world-more {
        display: flex;
        align-items: center;
        span {
          font-family: PingFang SC;
          font-weight: 500;
          font-size: 0.625rem;
          color: #1b0d00;
        }
        img {
          width: 0.375rem;
          height: 0.75rem;
          margin-left: 0.3125rem;
        }
      }
    }
    .world-list {
      margin-top: 1.25rem;
      .world-list-content {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .world-list-each {
          margin-right: 0.3125rem;
          margin-bottom: 0.8125rem;
          width: 48%;
          height: 6.875rem;
          position: relative;

          &:nth-child(2n) {
            margin-right: 0;
          }
          img {
            object-fit: cover;
            width: 100%;
            height: 100%;
            border-radius: 0.5rem;
            &:nth-last-child(1) {
              position: absolute;
              width: 2rem;
              height: 2rem;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
            }
          }
        }
      }
    }
  }
}

.not-message {
  position: absolute;
  top: 10%;
  width: 100%;
  left: 0;
  right: 0;
}

.overflw {
  overflow: hidden;
}
</style>
